export const environment = {
  base_url: 'https://sandbox.service.remitall.co.uk',
  allowed_origin: 'https://sandbox.app.remitall.co.uk',
  dataLimit: '20',
  production: false,
  envName: 'SANDBOX'
};
